import Vue, { VueConstructor } from 'vue';

import ListItems from '@/common/components/listItems/ListItems.vue';

export function registerVueGlobalComponent(vue: VueConstructor<Vue>) {
    [
        { component: ListItems, selector: 'listItems'}
    ]
    .forEach(config => vue.component(config.selector, config.component));
}